import React from 'react';
import { useLocation } from 'react-router-dom';
import { Phone, MessageCircle } from 'lucide-react';
import { getRandomWhatsAppNumber } from '../../utils/whatsapp';

export const StickyCTA = () => {
  const location = useLocation();

  // Determine WhatsApp message based on current page
  const getWhatsAppMessage = () => {
    // New dedicated Seashell marketing page
    if (location.pathname === '/seashell' || location.pathname === '/projects/seashell') {
      return "Hello, I'm interested in Seashell on the North Coast. Could you share more details about available units?";
    }
    if (location.pathname.includes('seashell-ras-el-hekma')) {
      return "Hello, I'm interested in Seashell Ras El Hekma. Could you provide more information about available units and payment plans?";
    }
    if (location.pathname.includes('playa-ghazala')) {
      return "Hello, I'm interested in Playa Ghazala. Could you provide more information about available units and payment plans?";
    }
    if (location.pathname.includes('playa-ras-el-hekma')) {
      return "Hello, I'm interested in Playa Ras El Hekma. Could you provide more information about available units and payment plans?";
    }
    if (location.pathname.includes('newkairo')) {
      return "Hello, I'm interested in NEWKAIRO. Could you provide more information about available units and investment opportunities?";
    }
    if (location.pathname.includes('newgiza')) {
      return "Hello, I'm interested in NEWGIZA. Could you provide more information about available units and payment plans?";
    }
    // IVY project
    if (location.pathname === '/ivy' || location.pathname === '/projects/ivy') {
      return "Hello, I'm interested in IVY. Could you share more details about available units and payment plans?";
    }
    // Hacienda Red project
    if (location.pathname === '/hacienda-red' || location.pathname === '/projects/hacienda-red') {
      return "Hello, I'm interested in Hacienda Red. Could you share more details about available units and payment plans?";
    }
    // The Collection project
    if (location.pathname === '/the-collection' || location.pathname === '/projects/the-collection') {
      return "Hello, I'm interested in The Collection. Could you share more details about available units and payment plans?";
    }
    // Artlife project
    if (location.pathname === '/artlife' || location.pathname === '/projects/artlife') {
      return "Hello, I'm interested in Artlife commercial district. Could you share more details about available units and investment opportunities?";
    }
    // Twilight Residences project
    if (location.pathname === '/twilight-residences' || location.pathname === '/projects/twilight-residences') {
      return "Hello, I'm interested in Twilight Residences at NEWGIZA. Could you share more details about available units and payment plans?";
    }
    // Ein Bay project
    if (location.pathname === '/ein-bay' || location.pathname === '/projects/ein-bay') {
      return "Hello, I'm interested in Ein Bay in Ain Sokhna. Could you share more details about available units and payment plans?";
    }
    // Default message
    return "Hello, I'm interested in G Developments projects and would like more details.";
  };

  const handleBookCall = () => {
    // Dispatch event to open lead modal if available, otherwise use tel link
    window.dispatchEvent(new CustomEvent('openLeadModal'));
  };

  const handleWhatsApp = () => {
    // Randomly select a WhatsApp number for load balancing (33% each)
    const selectedNumber = getRandomWhatsAppNumber();
    const message = encodeURIComponent(getWhatsAppMessage());
    window.open(`https://wa.me/${selectedNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button - Secondary */}
      <button
        onClick={handleWhatsApp}
        className="group flex items-center gap-2 px-5 py-3 bg-white border border-stone-200 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:border-stone-300"
        aria-label="Contact via WhatsApp"
      >
        <MessageCircle size={18} className="text-emerald-600" />
        <span className="text-sm font-medium text-stone-700 group-hover:text-stone-900 transition-colors">
          WhatsApp
        </span>
      </button>

      {/* Book a Call Button - Primary with gradient */}
      <button
        onClick={handleBookCall}
        className="group flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:from-blue-700 hover:to-purple-700 shadow-purple-500/25"
        aria-label="Book a Call"
      >
        <Phone size={18} className="text-white" />
        <span className="text-sm font-medium text-white">
          Book a Call
        </span>
      </button>
    </div>
  );
};
